import React from 'react'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

import { CheckboxStyledContainer, StyledSquare } from './styled'

interface Props {
  disabled?: boolean
  title?: string
  selected?: boolean
  onPress?: () => void
}

export const Checkbox = ({ title, disabled = false, selected, onPress }: Props) => {
  return (
    <Pressable disabled={disabled} onPress={onPress}>
      <CheckboxStyledContainer>
        <Box padding='sm'>
          <StyledSquare selected={selected}>
            {selected ? <Icon color='black' name='check' /> : null}
          </StyledSquare>
        </Box>
        <Box padding='sm'>
          <Text color='white' fontWeight='medium' align='left'>
            {title}
          </Text>
        </Box>
      </CheckboxStyledContainer>
    </Pressable>
  )
}
